import styled from 'styled-components';

import icon from '../../../images/tms-store-icon-pin.svg';
import ArrowIcon from '../../../images/chevron-right_black.svg';

interface ButtonProps {
  readonly activeStore: boolean;
}

export const Button = styled.button<ButtonProps>`
  position: relative;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  min-width: 0;
  width: 100%;
  max-width: 120px;
  cursor: pointer;
  background-color: #f6f6f8;
  border-radius: 10px;
  padding-right: 1rem;

  ${({ activeStore }) => activeStore && 'max-width: 185px;'}

  @media screen and (max-width: 1024px) {
    max-width: fit-content;
  }

  &:lang(fr) {
    max-width: 190px;

    @media screen and (max-width: 1024px) {
      max-width: fit-content;
    }
  }

  &::before {
    content: '';
    background-image: url(${icon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    width: 18px;
    height: 27px;
    margin-right: 9px;
    flex-shrink: 0;
  }

  &.mobile-menu {
    position: absolute;
    right: 110px;
    background-color: transparent;
    padding-right: 0;

    @media screen and (max-width: 300px) {
      display: none;
    }

    span {
      display: none;
    }
  }
`;

export const Content = styled.span`
  max-width: calc(100% - 38px);
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;

  .green {
    color: #276600;
  }

  .icon {
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;

    &::after {
      content: '';
      display: inline-block;
      background-image: url(${ArrowIcon});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      transform: rotate(90deg);
      width: 10px;
      height: 12px;
      margin-left: 6px;
      margin-bottom: 1px;
    }
  }
`;

export const StoreTitle = styled.span`
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StoreDetails = styled(StoreTitle)`
  max-width: calc(100% + 38px);
`;

export const Popup = styled.div`
  position: absolute;
  width: 200%;
  max-width: 145px;
  top: -66%;
  right: calc(100% + -3.15rem);
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  pointer-events: none;
  cursor: default;
  opacity: 0;
  color: #fff;
  background-color: #000;
  transform: scale(0.75) translateY(-50%);
  transform-origin: right center;
  transition:
    transform 0ms linear 400ms,
    opacity 250ms ease 150ms;

  @media screen and (max-width: 1024px) {
    width: 250px;
    top: 50%;
    right: calc(100% + 0.85rem);
  }

  @media screen and (max-width: 600px) {
    right: calc(64%);
    top: calc(100% + 0.5rem);
    margin-right: -0.25rem;
    transform: scale(0.75) translateX(50%);
    transform-origin: right top;
  }

  &.hasFocus {
    @media screen and (max-width: 600px) {
      right: calc(50%);
    }
  }

  &:lang(fr) {
    max-width: 230px;
    right: calc(100% + -4.8rem);

    @media screen and (max-width: 1024px) {
      right: calc(100% + 0.8rem);
    }

    &.hasFocus {
      @media screen and (max-width: 600px) {
        right: calc(50%);
      }

      &::before {
        left: 50%;
      }
    }
  }

  &.hidden {
    pointer-events: none;
    opacity: 0;
  }

  &.visible {
    pointer-events: all;
    opacity: 1;
    transform: scale(1) translateY(-50%);
    transition:
      transform 250ms ease-out,
      opacity 125ms ease-in;

    @media screen and (max-width: 600px) {
      transform: scale(1) translateX(50%);
    }
  }

  &::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    bottom: -8%;
    left: 68.2%;
    margin-bottom: -0.7rem;
    margin-left: -1px;
    border-style: solid;
    border-color: transparent;
    border-left-color: #000;
    border-left: 0.75rem solid transparent;
    border-right: 0.75rem solid transparent;
    border-top: 1rem solid #000;

    @media screen and (max-width: 1024px) {
      left: 98%;
      bottom: 47%;
      border-top: 0.75rem solid transparent;
      border-bottom: 0.75rem solid transparent;
      border-left: 1.25rem solid #000;
    }

    @media screen and (max-width: 600px) {
      bottom: 100%;
      left: 50%;
      margin-bottom: -1px;
      margin-left: -0.6rem;
      border-width: 0 0.6rem 0.75rem 0.6rem;
      border-left-color: transparent;
      border-bottom-color: #000;
    }
  }

  &:lang(fr) {
    &::before {
      @media screen and (max-width: 600px) {
        left: 60.5%;
      }
    }
  }
`;

export const CloseIcon = styled.div`
  width: 1rem;
  height: 1rem;
  overflow: hidden;
  border-radius: 50%;
  background: #fff;
  box-shadow: 1px 3px 4px rgba(0, 0, 0, 0.4);

  &::before,
  &::after {
    position: absolute;
    width: 50%;
    height: 2px;
    top: 50%;
    left: 50%;
    display: block;
    content: '';
    background: #000;
    transform: translateX(-50%) rotate(45deg);
  }

  &::after {
    transform: translateX(-50%) rotate(-45deg);
  }
`;

export const PopupCloseButton = styled.div`
  position: absolute;
  width: 2rem;
  height: 2rem;
  top: -0.75rem;
  right: -0.75rem;
  text-indent: -99999px;
  z-index: 10001;
  cursor: pointer;

  ${CloseIcon} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
`;
